import { render } from "./SwipersContent.vue?vue&type=template&id=8b9ec5be&scoped=true"
import script from "./SwipersContent.vue?vue&type=script&lang=js"
export * from "./SwipersContent.vue?vue&type=script&lang=js"

import "./SwipersContent.vue?vue&type=style&index=0&id=8b9ec5be&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b9ec5be"]])

export default __exports__